import React, { Component } from 'react';
import { Input, Menu, Button, Card, Row, Col, Dropdown, Icon, Popconfirm, Collapse, Form, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './profile.css';
import { throws } from 'assert';
import {InfoCircleOutlined} from '@ant-design/icons';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;

let isEditableFrame, pathName = false;
let WebContactId = 0
let webcontactitems = ""
class SocialInfoForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      actionbtn: false,
      SocialContacts: '',
      personGUID: '',
      socialnetworkIcon: [],
      socialnetworkType: [],
      existingwebcontacts: [],
      validatenetwork: [],
      showAddOption: true
    }
  }

  componentWillUnmount = () => {
    WebContactId = 0
  }

  componentDidMount = () => {
    this.props.actions.getSocialMediasLookups()
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    // this.props.actions.getProfileInfo(personGUID)
    
    const { pathname } = this.props.location;
    console.log('location.pathname ', pathname);

    if (pathname === '/my-profile' || pathname === '/manage-memberid' || pathname == '/alumni-dashboard') {
        pathName = pathname
        isEditableFrame = pathname === '/my-profile';
    }
  }

  cancelActions = () => {
    const { form } = this.props;
    const webcontactskeys = form.getFieldValue('webcontactskeys');
    form.setFieldsValue({
      webcontactskeys: [],
    });
    let web = form.getFieldValue('webcontactskeys');
    console.log('web', web);
    
    this.setState({
      validatenetwork: [],
      socialnetworkType : [],
      socialnetworkIcon : [],
      actionbtn: false
    })
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    this.props.actions.getProfileInfo(personGUID)
  }

  componentWillReceiveProps = (nextprops) => {
    if (nextprops.profileinfo) {
      if ((this.props.profileinfo ? this.props.profileinfo.profile.personId : "") !== nextprops.profileinfo.profile.personId) {
        WebContactId = 0;
        this.setState({ SocialContacts: this.state.SocialContacts = '', socialnetworkType: [], socialnetworkIcon: [], validatenetwork: [] });
        this.renderWebContacts(nextprops.profileinfo);
      }
    }
  }
  removeWebContacts = k => {
    const { form } = this.props;
    const webcontactskeys = form.getFieldValue('webcontactskeys');
    const SocialMediaValues = form.getFieldValue(`SocialMediaValues[${k}]`);

    webcontactskeys.splice(k, 1)
    form.setFieldsValue({
      webcontactskeys: webcontactskeys,
    });
    let web = form.getFieldValue('webcontactskeys');
    console.log('web', web);
    this.state.socialnetworkType.splice(k, 1);
    this.state.socialnetworkIcon.splice(k, 1);
    this.state.validatenetwork.splice(k, 1);
    this.setState({
      validatenetwork: this.state.validatenetwork,
      socialnetworkType : this.state.socialnetworkType,
      socialnetworkIcon :  this.state.socialnetworkIcon,
    })
    if(SocialMediaValues != '') {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    this.props.actions.getProfileInfo(personGUID)
  }
  };

  deleteWebContacts = (personGUID, id) => {
    let  socialnetworkType = this.state.socialnetworkType.filter(type => type.id != id);

    let socialnetworkIcon = this.state.socialnetworkIcon.filter(socialnetwork => {
      return this.props.socialmedialookup.every(lookUp => lookUp.id != id)
    })
    this.setState({
      validatenetwork: [],
      socialnetworkType,
      socialnetworkIcon,
      actionbtn: false
    })
    this.props.actions.deleteWebContacts(personGUID, id)
  }

  addWebContacts = () => {
    const { form } = this.props;
    const webcontactskeys = form.getFieldValue('webcontactskeys');
    const nextKeys = webcontactskeys ? webcontactskeys.concat(WebContactId++) : 0
    form.setFieldsValue({
      webcontactskeys: nextKeys,
    });

    this.renderSocialMedia()
  };



  renderSocialMedia = () => {
    if (this.props.socialmedialookup && this.state.validatenetwork) {
      let lookups = this.props.socialmedialookup
      let filters = this.state.validatenetwork
      webcontactitems = ""
      let filtered = lookups.filter(lookup => filters.every(filter => filter.toLowerCase() != lookup.name.toLowerCase() && lookup.name != "Other"));
      return filtered.map((k, index) => {
        if (k.name != "Other")
          // return webcontactitems = <Menu.Item key={k.id + "-" + k.name.toLowerCase()} > <i className={"themecolor networkIcon fa fa-" + k.name.toLowerCase()} aria-hidden='true'></i> {k.name} </Menu.Item>
        return webcontactitems = (
          <Menu.Item key={k.id + "-" + k.name.toLowerCase()}>
            {k.name.toLowerCase() === 'twitter' ? (
              <svg
                width="10"
                height="10"
                viewBox="0 0 1200 1227"
                fill="#003f87"
                aria-hidden="true"
                style={{
                  verticalAlign: 'middle',
                  // marginRight: '8px'
                }}
              >
                <path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" />
              </svg>
            ) : (
              <i
                className={"themecolor networkIcon fa fa-" + k.name.toLowerCase()}
                aria-hidden="true"
              ></i>
            )}
            {' '}
            {k.name}
          </Menu.Item>
        );
      })
    }
  }

  renderWebContacts = (profileinfo) => {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    let WebContacts = profileinfo.webContacts
    let optionvalue;
    (WebContacts.length == 4) ? optionvalue = false : optionvalue = true
    this.setState({
      showAddOption: optionvalue
    })
    if (this.state.SocialContacts == "") {
      this.setState({
        SocialContacts: WebContacts
      }, () => {
        WebContacts.map((k, index) => {
          this.setState(prevState => ({
            socialnetworkType: [...prevState.socialnetworkType, k.typeId],
            socialnetworkIcon: [...prevState.socialnetworkIcon, k.type.toLowerCase()],
            validatenetwork: [...prevState.validatenetwork, k.type]
          }), () => {
            this.addWebContacts()
          })
        });
      });
    }
  }

  textBoxOnchange = () => {
    this.setState({
      actionbtn: true
    })
  }

  handleMenuClick = e => {
    this.setState({
      actionbtn: true,
      socialnetworkType: [...this.state.socialnetworkType, e.key.split('-')[0]],
      socialnetworkIcon: [...this.state.socialnetworkIcon, e.key.split('-')[1]],
      validatenetwork: [...this.state.validatenetwork, e.key.split('-')[1]]
    })
    this.addWebContacts()
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { keys, names } = values;
        console.log('Received values of form: ', values);
        this.props.actions.UpdateSocialMeidaLinks(this.state.personGUID, this.state.socialnetworkType, values, 'alumni')
      }
    });
  }

  render() {
    if (this.props.updating) {
      return (
        <Row type='flex alumni-ui' style={{width: '25%' }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className='container min-height-710'>
              <div className='widget-content'>
                <Row type="flex" justify="space-between">
                  <div className='widget-header-text'>
                    SOCIAL MEDIA ACCOUNTS INFORMATION
                </div>
                  <div className='widget-header-tool'>
                    {/* <label className='pointer' onClick={this.showModal} > Add New </label> */}
                  </div>
                </Row>
                <Row className='widget-content-section' type="flex" justify="center" align="middle">
                  <Spin indicator={LoadingIcon} className="loading-state" tip="Updating Information..." />
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )
    }
    else if (this.props.profileinfo) {
      if (this.state.personGUID == '') {
        this.setState({
          personGUID: this.props.profileinfo.profile.personGuid
        })
      }
      const { getFieldDecorator, getFieldValue } = this.props.form;
      getFieldDecorator('webcontactskeys', { initialValue: [] });
      const webcontactskeys = getFieldValue('webcontactskeys');
      const twitterValidUrl = <span> https://twitter.com/<strong>username</strong> </span>
      const instagramValidUrl = <span> https://www.instagram.com/<b>username</b> </span>
      const facebookValidUrl = <span> https://www.facebook.com/<b>username</b> </span>
      const linkedinValidurl = <span> https://www.linkedin.com/in/<b>username</b> </span>
      const SocialMediaItems = webcontactskeys.map((k, index) => (
        <Row type='flex' justify='center' align='center'>
          <Col>
            {getFieldDecorator(`webcontactID[${index}]`, {
              initialValue: this.state.SocialContacts[index] ? this.state.SocialContacts[index].id : "",
            })(
              <input type='hidden' />
            )}
          </Col>
          <Col className='SocialMediaItemColumn' style={{ width: '91.55%', margin: '10px 0px' }} offset={2}>
            <FormItem className='SocialMediaItemRow' style={{ padding: '0px 10px 0px 0px', margin: '0px 0px 5px 0px' }} hasFeedback>
              {getFieldDecorator(`SocialMediaValues[${index}]`, {
                rules: [
                  {
                    required: true,
                    pattern:  new RegExp("^[a-zA-Z0-9_.@#/\\-]*$"),
                    message: "Please enter valid username!"
                  }
                ],
                initialValue: (this.state.SocialContacts[index]) ? (this.state.SocialContacts[index].address) : "",
              })(
              // <Input onChange={(e) => { this.textBoxOnchange() }} addonBefore={<i className={"webContactsIcon networkIcon fa-2x fa fa-" + this.state.socialnetworkIcon[index].toLowerCase()} aria-hidden='true'></i>} placeholder="" disabled={!isEditableFrame} />
              <Input
                onChange={(e) => {
                  this.textBoxOnchange();
                }}
                addonBefore={
                  this.state.socialnetworkIcon[index] &&
                  this.state.socialnetworkIcon[index].toLowerCase() === 'twitter' ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 1200 1227"
                      fill="white"
                      aria-hidden="true"
                      style={{
                        verticalAlign: 'middle'
                      }}
                    >
                      <path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" />
                    </svg>
                  ) : (
                    <i
                      className={
                        "webContactsIcon networkIcon fa-2x fa fa-" +
                        this.state.socialnetworkIcon[index].toLowerCase()
                      }
                      aria-hidden="true"
                    ></i>
                  )
                }
                placeholder=""
                disabled={!isEditableFrame}
              />
              )}
            </FormItem>
            {isEditableFrame && <div>
              {!getFieldValue(`SocialMediaValues[${index}]`) && <p className='SocialMedioValidateInfo' ><InfoCircleOutlined /> Please enter your { this.state.validatenetwork[index].toLowerCase() } username! </p>}
              <span className='SocialMediaValidateURL'>
                { this.state.validatenetwork[index].toLowerCase() === 'twitter' ? twitterValidUrl : '' }
                { this.state.validatenetwork[index].toLowerCase() === 'instagram' ? instagramValidUrl : '' }
                { this.state.validatenetwork[index].toLowerCase() === 'facebook' ? facebookValidUrl : '' }
                { this.state.validatenetwork[index].toLowerCase() === 'linkedin' ? linkedinValidurl : '' }
              </span>
              </div>}
          </Col>

          {isEditableFrame && <Col span={2}>
            <FormItem className='padding-0 m-t-10 social-del-i' hasFeedback>

              <Popconfirm placement="top" title="Are you sure to delete this?" onConfirm={() => this.state.SocialContacts[index] ? this.deleteWebContacts(this.state.personGUID, this.state.SocialContacts[index].id) : this.removeWebContacts(index)} okText="Yes" cancelText="No">
                <i
                  className="fa fa-trash-o red pointer fa-lg dynamic-delete-button"
                  style={{ color: 'red' }}
                ></i>
              </Popconfirm>
            </FormItem>
          </Col>}
        </Row>
      ));
      return (
        <Row type='flex alumni-ui' style={{width: '25%' }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className='container min-height-710'>
              <div className='widget-content'>
                <Row type="flex" align='middle' justify="space-between">
                  <div className='widget-header-text'>
                    My Social Media Accounts
                </div>
                  <div className='widget-header-tool'>
                    {(this.state.showAddOption && isEditableFrame) &&
                      <FormItem>
                        {getFieldDecorator('AddSocialNetwork', {
                          initialValue: "",
                        })(
                          <Dropdown overlay={
                            <Menu onClick={this.handleMenuClick}>
                              {
                                this.renderSocialMedia()
                              }
                            </Menu>
                          } trigger={['click']}>
                            <a className="ant-dropdown-link" href="#">
                              <i class="fa fa-plus-circle" aria-hidden="true"></i> Add Social Accounts <Icon type="down" />
                            </a>
                          </Dropdown>
                        )}
                      </FormItem>
                    }
                  </div>
                </Row>
                <Row className='widget-content-section flex-center' type="flex" justify="center" align="center">
                  <Form onSubmit={this.handleSubmit} className="width-100 padding-15 paddingNone">
                    <div className='edit-mode'>

                          {SocialMediaItems}

                      {this.state.actionbtn &&
                        <Row type='flex' className='btn-action' justify='space-around' style={{ margin: '10px 0px 0px 0px' }}>
                          {/* <Col xs={23} sm={23} md={18} lg={18} xl={18}> */}
                            <Row type='flex' justify='space-around'>
                              <Col xs={12} sm={12} md={6} style={{ textAlign: '', marginRight: '10px' }}>
                                {/* <FormItem> */}
                                  <Button onClick={() => this.cancelActions()} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '5px 42px' }}>CANCEL</Button>
                                {/* </FormItem> */}
                              </Col>
                              <Col xs={12} sm={12} md={6} style={{ textAlign: '' }}>
                                {/* <FormItem> */}
                                  <Button htmlType="submit" type="primary" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '5px 42px' }}>SAVE</Button>
                                {/* </FormItem> */}
                              </Col>
                            </Row>
                          {/* </Col> */}
                        </Row>
                      }
                    </div>
                  </Form>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )
    }

    else {
      return (
        <Row type='flex alumni-ui' style={{width: '25%' }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className='container min-height-710'>
            <div className='widget-content'>
              <Row type="flex" align='middle' justify="space-between">
                <div className='widget-header-text'>
                    SOCIAL MEDIA ACCOUNTS INFORMATION
                </div>
                  <div className='widget-header-tool'>
                    {/* <label className='pointer' onClick={this.showModal} > Add New </label> */}
                  </div>
                </Row>
                <Row className='widget-content-section' type="flex" justify="center" align="middle">
                  <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )
    }
  }
}


function mapStateToProps(state) {
  return {
    loading: state.profilereducer.loading,
    profileinfo: state.profilereducer.profileinfo,
    updating: state.webcontactreducer.loading,
    socialmedialookuploading: state.socialmedialookupreducer.loading,
    socialmedialookup: state.socialmedialookupreducer.socialmedialookup
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}
const SocialInfo = Form.create()(SocialInfoForm);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(SocialInfo);


// WEBPACK FOOTER //
// ./src/components/MyProfile/SocialInfo.js